<template>
  <div>
    <b-card
      no-body
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Search -->
          <b-col
            cols="12"
            class="d-flex justify-content-between"
          >
            <b-button
              v-b-modal.campaign-add-new
              variant="primary"
              style="text-transform: capitalize"
            >
              {{ $t('contract.btn.addCampaign') }}
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refCampaignListTable"
        :items="fetchCampaignList"
        :fields="tableColumns"
        :empty-text="$t('no_matching_records')"
        show-empty
        responsive
        class="position-relative"
      >
        <!-- Column: created -->
        <template #cell(created)="{ value }">
          <span
            class="font-weight-bold"
          >
            {{ typeof(value) === 'object' ? value.toDate().toLocaleDateString('fi') : '' }}
          </span>
        </template>

        <!-- Column: name -->
        <template #cell(name)="data">
          <b-link
            :to="{ name: 'apps-campaigns-view', params: { id: data.item.id } }"
            class="font-weight-bold d-block text-nowrap"
            style="text-transform: capitalize"
          >
            {{ data.value }}
          </b-link>
        </template>

        <!-- Column: start date -->
        <template #cell(startDate)="{ value }">
          <span>
            {{ typeof(value) === 'object' ? value.toDate().toLocaleDateString('fi') : '' }}
          </span>
        </template>

        <!-- Column: end date -->
        <template #cell(endDate)="{ value }">
          <span>
            {{ typeof(value) === 'object' ? value.toDate().toLocaleDateString('fi') : '' }}
          </span>
        </template>

        <!-- Column: salary -->
        <template #cell(salary)="{ value }">
          <ul
            class="p-0 m-0"
            style="list-style: none;"
          >
            <li
              v-for="[k, v] of Object.entries(value)"
              :key="`salary-${k}`"
              style="text-transform: capitalize"
            >
              <b-badge variant="secondary">
                {{ k }}: {{ v }} €
              </b-badge>
            </li>
          </ul>
        </template>

        <!-- Column: price -->
        <template #cell(price)="{ value }">
          <ul
            class="p-0 m-0"
            style="list-style: none;"
          >
            <li
              v-for="[k, v] of Object.entries(value)"
              :key="`price-${k}`"
              style="text-transform: capitalize"
            >
              <b-badge variant="primary">
                {{ k }}: {{ v }} €
              </b-badge>
            </li>
          </ul>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="{ item }">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.hwUiLayout.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="handleEditCampaign(item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('edit') }}</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="!item.delete"
              v-b-modal.modal-danger
              @click="docItem = item"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{ $t('delete') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>

    <campaign-add-new
      :doc-item="docItem"
      :check-campaign-exist="checkCampaignExist"
      @create-or-update-campaign="createOrUpdateCampaign"
      @hide="docItem = null"
    />

    <b-modal
      id="modal-danger"
      ok-only
      ok-variant="danger"
      ok-title="Delete"
      modal-class="modal-danger"
      centered
      title="Deleting Campaign"
      @ok="confirmDelete"
      @hide="docItem = null"
    >
      <b-card-text>
        {{ $t('contract.warningText.deleteCampaign') }}
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BCard, BTable, BDropdown, BDropdownItem,
  BCardText, BLink, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useCampaignList from './useCampaignList'
import CampaignAddNew from './CampaignAddNew.vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BTable,
    BDropdown,
    BDropdownItem,
    BCardText,
    BLink,
    BBadge,

    CampaignAddNew,
  },
  directives: {
    Ripple,
  },
  methods: {
    handleEditCampaign(item) {
      this.docItem = item
      this.$nextTick(() => {
        this.$bvModal.show('campaign-add-new')
      })
    },
  },
  setup() {
    const {
      docItem,
      refCampaignListTable,
      tableColumns,
      fetchCampaignList,
      createOrUpdateCampaign,
      confirmDelete,
      checkCampaignExist,
    } = useCampaignList()

    return {
      docItem,
      refCampaignListTable,
      tableColumns,
      fetchCampaignList,
      createOrUpdateCampaign,
      confirmDelete,
      checkCampaignExist,
    }
  },
}
</script>

<style>

</style>
